import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const SidebarItemContainer = styled.li`
  .interview-link {
    text-decoration: none;
    color: #ecf0f1;
    font-weight: bold;
    display: block;
    padding: 10px;
    text-align: left;
    border-radius: 4px;
    transition: background-color 0.3s ease;
  }

  .interview-link.selected,
  .interview-link:hover {
    background-color: ${darken(0.1, '#2c3e50')};
  }
`;
